import { useClient } from 'jsonapi-react';
import toast from 'react-hot-toast';
import { DialogContent } from '@/components/ui/dialog';
import { AvatarWrapper } from '@/components/ui/avatar';
import { DuelNotification, DuelNotificationButtons, DuelNotificationContent, DuelNotificationName } from '@/components/custom/duel';
import { Button } from '@/components/ui/button';

export function DuelsAccept({ duel, setOpen, updateDuelsAndRequests }) {
  const client = useClient();

  const handleAcceptDuel = async () => {
    const { error } = await client.mutate(`duels/${duel.id}/accept`, {}, { method: 'PUT' });

    if (error) {
      toast.error('Erro ao aceitar duelo');
    }

    setOpen(false);
    updateDuelsAndRequests();
  };

  const handleRefuseDuel = async () => {
    const { error } = await client.mutate(`duels/${duel.id}/refuse`, {}, { method: 'PUT' });

    if (error) {
      toast.error('Erro ao recusar duelo');
    }

    setOpen(false);
    updateDuelsAndRequests();
  };

  return (
    <DialogContent
      size="sm"
      className="!p-0"
    >
      <DuelNotification>
        <AvatarWrapper
          size="md"
          src={duel?.opponent?.image?.url}
          text="Foto do usuário"
        />

        <DuelNotificationContent>
          <DuelNotificationName>{duel?.opponent?.name}</DuelNotificationName>
          <p className="mb-0">te desafiou para um duelo</p>
          <p className="mb-0">Responda antes que o convite expire</p>

          <DuelNotificationButtons>
            <Button
              variant="outline"
              onClick={handleAcceptDuel}
            >
              Aceitar
            </Button>
            <Button
              variant="ghost"
              onClick={handleRefuseDuel}
            >
              Recusar
            </Button>
          </DuelNotificationButtons>
        </DuelNotificationContent>
      </DuelNotification>
    </DialogContent>
  );
}
